import React, { Component } from 'react';
import { Fade } from 'reactstrap';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';
import isEqual from 'lodash/isEqual';

import api from '../../../lib/api';
import endpoints from '../../../lib/endpoints';
import { VERIFICATION_KEYS } from '../../../constants/admin';

const textStyle = {
  textTransform: 'capitalize',
  margin: '0 5px',
};

const CustomCheckBox = ({ value }) => (
  <label style={textStyle}>
    <Checkbox value={value} /> <span /> {value.split('_').join(' ')}
  </label>
);

export default class VerifyGuide extends Component {
  state = {
    isSaving: false,
    error: false,
    checkedValues: this.props.verifiedValues,
  };

  toggleisSaving = () => this.setState(prevState => ({ isSaving: !prevState.isSaving }));

  toggleError = () => this.setState(prevState => ({ error: !prevState.error }));

  handleChange = newValues => {
    this.setState({
      checkedValues: newValues,
    });
  };

  toggleSelect = () => {
    if (this.isAllSelected()) {
      this.setState({
        checkedValues: [],
      });
    } else {
      this.setState({
        checkedValues: VERIFICATION_KEYS,
      });
    }
  };

  handleSave = async () => {
    const { checkedValues } = this.state;
    const { id, updateData } = this.props;

    const modifiedPutData = {};
    VERIFICATION_KEYS.forEach(value => {
      if (checkedValues.includes(value)) {
        modifiedPutData[value] = true;
      } else {
        modifiedPutData[value] = false;
      }
    });
    this.toggleisSaving();
    try {
      const { data } = await api.put(endpoints.admin.verifyGuide(id), modifiedPutData);
      updateData(data);
      this.toggleisSaving();
    } catch (err) {
      this.toggleError();
      this.toggleisSaving();
    }
  };

  hasStateChanged = () => {
    const { checkedValues } = this.state;
    const { verifiedValues } = this.props;

    return !isEqual(verifiedValues.sort(), checkedValues.sort());
  };

  isAllSelected = () => {
    const { checkedValues } = this.state;
    return checkedValues.length === 4;
  };

  render() {
    const { isSaving, checkedValues, error } = this.state;
    return (
      <Fade in={true}>
        <CheckboxGroup name="fruits" value={checkedValues} onChange={this.handleChange}>
          {VERIFICATION_KEYS.map(keys => (
            <CustomCheckBox key={keys} value={keys} />
          ))}
        </CheckboxGroup>
        <a onClick={this.toggleSelect} className="mt-3">
          {this.isAllSelected() ? 'Select None' : 'Select All'}
        </a>
        {isSaving ? (
          'Saving Changes...'
        ) : this.hasStateChanged() ? (
          <a onClick={this.handleSave} className="mt-3 ml-4">
            {error ? 'Api error. try again' : 'Save'}
          </a>
        ) : null}
      </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/VerifyGuide.js